import { Component, OnInit, ElementRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as utils from '../common/utils';
import { ZIndexMngr } from '../common/ZIndexMngr';
import * as projMsgs from '../../../app/msg/projMsgs';
import { AppInjector } from '@core_n/common/inject';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as units from '@core_n/common/units';
import * as enums from '@core_n/common/enums';
import * as consts from '@core_n/common/consts';
import { SensorObject } from 'src/app/asp/SensorObject';
import * as aspObjects from '../../app/asp/aspObjects';
import { mainMapMngr } from '../asp/MapMngr';
import { FreeDrawingObject, FreeDrawingsPool } from '@core_n/asp/free-drawings';
import * as projEnums from '../../../app/common/projEnums';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as settings from '../common/settings';
import { boolToStr } from '@core_n/aro/aro';
import { Animations } from './../Animations';

@Component({
  selector: 'alert-polygon-dialog',
  templateUrl: './alert-polygon.component.html',
  styleUrls: ['./alert-polygon.component.scss'],
  animations: [
    Animations.BlinkRedError,
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class AlertPolygonDialogComponent extends ZIndexMngr implements OnInit, OnDestroy, AfterViewInit {
  static readonly DIALOG_ID = 'alertPolygon';
  alertPolygonObj: AlertPolygonObject = new AlertPolygonObject();
  natNaiGeometry: any;
  private currentColor: string;
  freeDrawId: string;
  isActiveTool: boolean = false;
  buttonText: string = 'Draw';
  strNatNai: string;
  translations: any = [];
  public Form: FormGroup;
  AltValid = [Validators.required, Validators.max(settings.MAXNAINATALTITUDE), Validators.min(settings.MINNAINATALTITUDE), Validators.maxLength(6)];
  sicsacValid = [Validators.required, Validators.min(0), Validators.maxLength(5)];

  // Units
  myunits: number = 0;
  UnitsNum: number = 0;
  Units: string = "";

  // animations controls
  public state: boolean = false;

  public activeAnimErrSic: boolean = false;
  public blinkAnimErrSic: boolean = false;

  public activeAnimErrSac: boolean = false;
  public blinkAnimErrSac: boolean = false;

  public activeAnimErrMinAlt: boolean = false;
  public blinkAnimErrMinAlt: boolean = false;

  public activeAnimErrMaxAlt: boolean = false;
  public blinkAnimErrMaxAlt: boolean = false;

  public activeAnimErrGeo: boolean = false;
  public blinkAnimErrGeo: boolean = false;

  constructor(public dialogRef: MatDialogRef<AlertPolygonDialogComponent>,
    elementRef: ElementRef, private translateService: TranslateService,
    private fb: FormBuilder) {
    super(elementRef);

    if (translateService) {
      translateService.get('NAT_NAI').subscribe(translations => {
        this.translations = translations;
      });
      this.buttonText = this.translations['DRAW'];
      this.strNatNai = this.translations['NAT_NAI'];
    }

    this.freeDrawId = null;
    this.currentColor = '#FFFF00';
    // this.alertPolygonObj.Sic = 0;
    // this.alertPolygonObj.Sac = 0;
    this.alertPolygonObj.NaiNatId = 0;
    this.alertPolygonObj.MinAltitude = 0;
    this.alertPolygonObj.MaxAltitude = 30000;
    this.alertPolygonObj.CircleLatitude = 0;
    this.alertPolygonObj.CircleLongitude = 0;
    this.alertPolygonObj.CircleRadius = 0;
    this.alertPolygonObj.RadarEndAngle = 0;
    this.alertPolygonObj.RadarStartAngle = 0;
    this.alertPolygonObj.RadarRadius = 0;

    this.alertPolygonObj.PolygonPoints = [];
    for (let i = 0; i < 3; i++) {
      this.alertPolygonObj.PolygonPoints[i] = new PolygonPoint();
      this.alertPolygonObj.PolygonPoints[i].Lat = 0;
      this.alertPolygonObj.PolygonPoints[i].Long = 0;
    }
    this.alertPolygonObj.GeometricShape = 0;
    this.alertPolygonObj.OperationAction = 0;
    this.alertPolygonObj.NaiOrNat = projEnums.NaiOrNat.Nai;

    this.myunits = settings.userSettings.displayUnits;
    this.UnitsNum = settings.userSettings.displayUnits;
    this.Units = units.altitudeUnitsVal(this.UnitsNum);
    this.changeRadiusValidation();

    let self = this;
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  static createDialogConfig(upperBarHeight: number) {
    return utils.createDialogConfig(false, false, AlertPolygonDialogComponent.DIALOG_ID,
      { top: `${upperBarHeight + 5}px`, right: `80px` });
  }

  ngOnInit() {
    this.dialogRaise();
    let maxalt = 0;
    if (this.UnitsNum == 0) { // imperial
      maxalt = settings.MAXNAINATALTITUDE * 10 * units.METER_TO_FEET;
    } else { // metric
      maxalt = settings.MAXNAINATALTITUDE;
    }

    this.Form = this.fb.group({
      minalt: [0, this.AltValid],
      maxalt: [maxalt, this.AltValid],
      sac: [this.alertPolygonObj.Sac, this.sicsacValid],
      sic: [this.alertPolygonObj.Sic, this.sicsacValid],
    });
  }

  ngOnDestroy(): void {
    this.deleteDrawings();
    this.dialogClosed();
  }

  protected refresh(): void {
    if (this.myunits != settings.userSettings.displayUnits) {
      this.myunits = settings.userSettings.displayUnits;
      this.changeMetricSystem();
    }

    // animation triggers and setters
    this.state = !this.state;

    //Dmm Latitude
    if (this.activeAnimErrSic) { this.blinkAnimErrSic = this.state; }
    else { this.blinkAnimErrSic = false; }
    if (this.activeAnimErrSac) { this.blinkAnimErrSac = this.state; }
    else { this.blinkAnimErrSac = false; }
    if (this.activeAnimErrMinAlt) { this.blinkAnimErrMinAlt = this.state; }
    else { this.blinkAnimErrMinAlt = false; }
    if (this.activeAnimErrMaxAlt) { this.blinkAnimErrMaxAlt = this.state; }
    else { this.blinkAnimErrMaxAlt = false; }
    if (this.activeAnimErrGeo) { this.blinkAnimErrGeo = this.state; }
    else { this.blinkAnimErrGeo = false; }
  }

  saveNaiParameters() {
    let err = false;

    if (!this.Form.controls.sic.valid) {
      this.activeAnimErrSic = true;
      err = true;
    }

    if (!this.Form.controls.sac.valid) {
      this.activeAnimErrSac = true;
      err = true;
    }

    if (!this.Form.controls.minalt.valid) {
      this.activeAnimErrMinAlt = true;
      err = true;
    }

    if (!this.Form.controls.maxalt.valid) {
      this.activeAnimErrMaxAlt = true;
      err = true;
    }

    let object = aspObjects.sensorsPool.getSensorBySicSac(this.Form.value.sic, this.Form.value.sac) as SensorObject;
    if (!object) {
      this.activeAnimErrSic = true;
      this.activeAnimErrSac = true;
      err = true;
    }

    if (!this.natNaiGeometry) {
      this.activeAnimErrGeo = true;
      err = true;
    }

    if (err) {
      return;
    }

    if (this.alertPolygonObj.OperationAction == projEnums.NatNaiOperationAction.Update &&
      this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Polygon) {
      let finishedGeometry = mainMapMngr.getEditFinishedGeometry();
      if (finishedGeometry['_isSelfIntersect']() == false)
        this.natNaiGeometry = finishedGeometry;
      else {
        alert(this.translations['POLYGON_SELF_INTERSECT']);
        this.isActiveTool = false;
        return;
      }
    }
    this.sendNaiParameters();
    this.dialogClosed();
    this.dialogRef.close();
  }

  deleteDrawings() {
    this.deactivateTool();
    let objects = FreeDrawingsPool.getSelf().getAllObjects();
    if (objects) {
      for (let drawing of objects.values()) {
        if (drawing.id == this.freeDrawId) {
          FreeDrawingsPool.getSelf().deleteObj(drawing as FreeDrawingObject);
        }
      }
    }
  }

  public onDrawShapeClick() {
    this.activeAnimErrGeo = false;
    this.isActiveTool = true;
    if (this.alertPolygonObj.NaiOrNat == projEnums.NaiOrNat.Nai)
      this.currentColor = '#FFFF00';
    else
      this.currentColor = '#d3d3d3';

    if (this.natNaiGeometry) {
      this.deleteDrawings();
    }
    if (this.alertPolygonObj.OperationAction == projEnums.NatNaiOperationAction.Update) {
      if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Polygon)
        mainMapMngr.activateEditTool(this.natNaiGeometry);
      else
        mainMapMngr.activateCreateTool(NeWMI.Geometry.Enums.EGeometryType.Circle, this.onCreateToolFinish.bind(this));
    }
    else if (this.alertPolygonObj.OperationAction == projEnums.NatNaiOperationAction.Create) {
      if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Polygon)
        mainMapMngr.activateCreateTool(NeWMI.Geometry.Enums.EGeometryType.Polygon, this.onCreateToolFinish.bind(this));
      else
        mainMapMngr.activateCreateTool(NeWMI.Geometry.Enums.EGeometryType.Circle, this.onCreateToolFinish.bind(this));
    }
  }

  private onCreateToolFinish(geometry: any) {
    if (geometry['_isSelfIntersect']() == false) {
      this.natNaiGeometry = geometry;
      this.freeDrawId = FreeDrawingsPool.getSelf().createNatNaiDrawing(geometry, this.currentColor, false);
      mainMapMngr.redrawMap();
    }
    else {
      alert(this.translations['POLYGON_SELF_INTERSECT']);
    }

    this.isActiveTool = false;
  }

  private deactivateTool() {
    if (this.isActiveTool)
      mainMapMngr.activateDefaultTool();
  }

  sendNaiParameters() {
    let obj = new projMsgs.Nai();
    obj.AlertPolygonObj = new AlertPolygonObject();
    if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Circle) {
      obj.AlertPolygonObj.CircleRadius = NeWMI.Service.Math.ConversionsSvc.simpleDegreesToMetersConversion(this.natNaiGeometry.radius, this.natNaiGeometry.x, this.natNaiGeometry.y); //;this.natNaiGeometry.radius;
      obj.AlertPolygonObj.CircleLatitude = this.natNaiGeometry.y * units.DEG_TO_RAD;
      obj.AlertPolygonObj.CircleLongitude = this.natNaiGeometry.x * units.DEG_TO_RAD;
    }
    else if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Polygon) {
      obj.AlertPolygonObj.PolygonPoints = [];
      this.natNaiGeometry.points.forEach(point => {
        let polygonPoint = { Lat: point.y * units.DEG_TO_RAD, Long: point.x * units.DEG_TO_RAD }
        obj.AlertPolygonObj.PolygonPoints.push(polygonPoint);
      });
    }
    obj.AlertPolygonObj.GeometricShape = this.alertPolygonObj.GeometricShape;
    if (this.UnitsNum == 0) { // imperial
      // this.AltValid = [Validators.required, Validators.max(settings.MAXNAINATALTITUDE * 10 * units.METER_TO_FEET), Validators.min(settings.MINNAINATALTITUDE * 10 * units.METER_TO_FEET), Validators.maxLength(8)];
      obj.AlertPolygonObj.MaxAltitude = this.Form.value.maxalt * units.FEET_TO_METER;
      obj.AlertPolygonObj.MinAltitude = this.Form.value.minalt * units.FEET_TO_METER;
    }
    else if (this.UnitsNum == 1) { // metric
      // this.AltValid = [Validators.required, Validators.max(settings.MAXNAINATALTITUDE), Validators.min(settings.MINNAINATALTITUDE), Validators.maxLength(4)];
      obj.AlertPolygonObj.MaxAltitude = this.Form.value.maxalt * 1000;
      obj.AlertPolygonObj.MinAltitude = this.Form.value.minalt * 1000;
    }
    obj.AlertPolygonObj.NaiNatId = this.alertPolygonObj.NaiNatId;
    obj.AlertPolygonObj.NaiOrNat = this.alertPolygonObj.NaiOrNat;
    obj.AlertPolygonObj.Sac = this.Form.value.sac;
    obj.AlertPolygonObj.Sic = this.Form.value.sic;
    obj.AlertPolygonObj.OperationAction = this.alertPolygonObj.OperationAction;

    AppInjector.get(UserActionService).sendUserAction(obj);
  }

  checkInputsValid(): string {
    let strError = null;
    let object = aspObjects.sensorsPool.getSensorBySicSac(this.alertPolygonObj.Sic, this.alertPolygonObj.Sac) as SensorObject;
    if (!object) {
      strError = this.translations['SENSOR_NOT_EXIST'];
    }
    else if (this.alertPolygonObj.OperationAction != projEnums.NatNaiOperationAction.Delete) {
      if (!this.alertPolygonObj.Sic || (this.alertPolygonObj.Sic && this.alertPolygonObj.Sic <= 0))
        strError = this.translations['SIC_NOT_VALID']; //"Sic is not valid.";
      else if (!this.alertPolygonObj.Sac || (this.alertPolygonObj.Sac && this.alertPolygonObj.Sac <= 0))
        strError = this.translations['SAC_NOT_VALID'];
      else if (this.alertPolygonObj.MinAltitude < settings.MINNAINATALTITUDE)
        strError = this.translations['NIN_ALTITUDE_NOT_VALID'];
      else if (this.alertPolygonObj.MaxAltitude > settings.MAXNAINATALTITUDE)
        strError = this.translations['NAX_ALTITUDE_NOT_VALID'];
      else if (this.alertPolygonObj.MinAltitude >= this.alertPolygonObj.MaxAltitude)
        strError = this.translations['ALTITUDE_NOT_VALID'];

      if (!strError || strError == "!") {
        if (!this.natNaiGeometry) {
          if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Polygon)
            strError = this.translations['POLYGON_NOT_VALID'];
          else if (this.alertPolygonObj.GeometricShape == projEnums.GeometricShape.Circle)
            strError = this.translations['CIRCLE_NOT_VALID'];
        }
      }
    }

    return strError;
  }

  deleteNatNai(natNaiId: number, sic: number, sac: number) {
    let obj = new projMsgs.Nai();
    this.alertPolygonObj.Sic = sic;
    this.alertPolygonObj.Sac = sac;
    this.alertPolygonObj.NaiNatId = natNaiId;
    this.alertPolygonObj.OperationAction = projEnums.NatNaiOperationAction.Delete;
    obj.AlertPolygonObj = this.alertPolygonObj;
    AppInjector.get(UserActionService).sendUserAction(obj);
  }

  setSensorNatNai(sensor: SensorObject, operationAction: number) {
    if (sensor) {
      this.alertPolygonObj.Sic = sensor.sic;
      this.alertPolygonObj.Sac = sensor.sac;
      this.alertPolygonObj.NaiNatId = 0;
      this.alertPolygonObj.OperationAction = operationAction;
      this.buttonText = this.buttonText = this.translations['DRAW'];
      if (operationAction == projEnums.NatNaiOperationAction.Update) {
        this.alertPolygonObj.NaiNatId = sensor.naiNatAreaObject.naiNatId;
        this.alertPolygonObj.NaiOrNat = sensor.naiNatAreaObject.naiOrNat;
        this.natNaiGeometry = sensor.naiNatAreaObject.naiNatShape;
        this.alertPolygonObj.PolygonPoints = sensor.naiNatAreaObject.polygonPoints;
        this.alertPolygonObj.MaxAltitude = sensor.naiNatAreaObject.maxAltitude;
        this.alertPolygonObj.MinAltitude = sensor.naiNatAreaObject.minAltitude;
        this.alertPolygonObj.GeometricShape = sensor.naiNatAreaObject.geometricShape;
        this.alertPolygonObj.CircleRadius = sensor.naiNatAreaObject.circleRadius;
        this.alertPolygonObj.CircleLongitude = sensor.naiNatAreaObject.circleLongitude;
        this.alertPolygonObj.CircleLatitude = sensor.naiNatAreaObject.circleLatitude;
        this.buttonText = this.buttonText = this.translations['EDIT'];
        this.strNatNai = (this.alertPolygonObj.NaiOrNat == projEnums.NaiOrNat.Nai) ? this.translations['NAI'] : this.translations['NAT'];
      }
      else if (operationAction == projEnums.NatNaiOperationAction.Delete) {
        this.alertPolygonObj.NaiNatId = sensor.naiNatAreaObject.naiNatId;
        let obj = new projMsgs.Nai();
        obj.AlertPolygonObj = this.alertPolygonObj;
        AppInjector.get(UserActionService).sendUserAction(obj);
      }
    }
  }

  changeMetricSystem() {
    this.UnitsNum = units.nextDisplayUnit(this.UnitsNum);
    this.changeRadiusValidation();
    this.Units = units.altitudeUnitsVal(this.UnitsNum);
    let minalt = units.altitudeValueFix(this.UnitsNum, this.Form.value.minalt);
    let maxalt = units.altitudeValueFix(this.UnitsNum, this.Form.value.maxalt);
    minalt = Number.parseFloat(minalt.toFixed(2));
    maxalt = Number.parseFloat(maxalt.toFixed(2));
    let sic = this.Form.controls.sic.value;
    let sac = this.Form.controls.sac.value;
    this.Form = this.fb.group({
      minalt: [minalt, this.AltValid],
      maxalt: [maxalt, this.AltValid],
      sac: [sac, this.sicsacValid],
      sic: [sic, this.sicsacValid],
    });
  }

  changeRadiusValidation() {
    if (this.UnitsNum == 0) { // imperial
      this.AltValid = [Validators.required, Validators.max(settings.MAXNAINATALTITUDE * 10 * units.METER_TO_FEET), Validators.min(settings.MINNAINATALTITUDE * 10 * units.METER_TO_FEET), Validators.maxLength(8)];
    }
    else if (this.UnitsNum == 1) { // metric
      this.AltValid = [Validators.required, Validators.max(settings.MAXNAINATALTITUDE), Validators.min(settings.MINNAINATALTITUDE), Validators.maxLength(4)];
    }
  }
}

export class AlertPolygonObject {
  NaiOrNat: number;   // 1 - nai , 2 - nat
  Sic: number;
  Sac: number;
  NaiNatId: number;
  OperationAction: number;
  GeometricShape: number;
  MinAltitude: number;
  MaxAltitude: number;
  CircleLatitude: number;
  CircleLatDegrees: boolean;
  CircleLongitude: number;
  CircleLongDegrees: boolean;
  CircleRadius: number;
  RadarStartAngle: number;
  RadarStartAngleDegrees: boolean;
  RadarEndAngle: number;
  RadarEndAngleDegrees: boolean;
  RadarRadius: number;
  PolygonDegress: boolean;
  PolygonPoints: PolygonPoint[];
}

class PolygonPoint {
  Lat: number;
  Long: number;
}
